import React from 'react'

import { Field } from 'formik'

import { Form, Col } from '_zari/core'

import { ContactoSocioSelect } from 'sharedComponents/select'

const ContactoSocioFormGroup = ({ vIdSocio, iError, iTouched, fIsSubmitting, setFieldValue }) => {
  const oneRowTrigger = React.useCallback(
    row => {
      setFieldValue('_idContactoSocio', row._id)
    },
    [setFieldValue]
  )

  const seleccionarContactoCreadaHandler = React.useCallback(
    ({ _id }, closeModal, refreshSelect) => {
      refreshSelect().then(() => {
        setFieldValue('_idContactoSocio', _id)
        closeModal()
      })
    },
    [setFieldValue]
  )

  return (
    <>
      <Form.Group>
        <Form.Label text='CONTACTO' htmlFor='select-idContactoSocio' md={3} alignRightAt='md' />
        <Col md={9}>
          <Field name='_idContactoSocio'>
            {({ field }) => (
              <ContactoSocioSelect
                {...field}
                idSocio={vIdSocio}
                onCreate={seleccionarContactoCreadaHandler}
                showNewButton
                oneRowTrigger={oneRowTrigger}
                id='select-idContactoSocio'
                isInvalid={iTouched && iError}
                disabled={fIsSubmitting || vIdSocio === ''}
              />
            )}
          </Field>
          {iTouched && iError ? <Form.Feedback type='invalid'>{iError}</Form.Feedback> : null}
        </Col>
      </Form.Group>
    </>
  )
}

export default React.memo(ContactoSocioFormGroup)
